module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Fish-59be55cb57fb1f3044be8f0a6a454dbe.svg";